export default __webpack_public_path__ + "static/main-img01-751a6deee68d0bf88fb924895e677aac.jpg";